function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 14.143h3.857M8.571 9h10.286M15 14.143h9M46.89 41H41",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M52.179 53c-.65 0-1.179.551-1.179 1.23v.01c0 .675.522 1.225 1.17 1.23.654.005 1.188-.547 1.188-1.23v-.01c0-.679-.528-1.23-1.18-1.23zM23.179 53c-.65 0-1.179.551-1.179 1.23v.01c0 .675.522 1.225 1.17 1.23.654.005 1.188-.547 1.188-1.23v-.01c0-.679-.528-1.23-1.18-1.23zM46.279 54.279H29.116M53.778 34.822l-4.722-10.813a2.013 2.013 0 00-1.84-1.195h-5.75a.954.954 0 00-.954.953v11.442c0 .526.427.953.953.953h11.441c.69 0 1.152-.71.872-1.34v0z",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.674 54.28h-5.72a.954.954 0 01-.954-.954V19.953c0-.526.427-.953.954-.953h36.263a5.826 5.826 0 015.324 3.46l6.034 13.582c.036.08.082.155.139.223l4.461 5.354a.952.952 0 01.221.61v11.097a.954.954 0 01-.953.953h-5.721",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.396 60a5.721 5.721 0 100-11.442 5.721 5.721 0 000 11.442zM52 60a5.721 5.721 0 100-11.442A5.721 5.721 0 0052 60z",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14 60h46M64.33 41.884h-4.702a.954.954 0 00-.953.953v1.907c0 .527.427.954.953.954h4.768M34 19v17",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgTruckDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default __webpack_public_path__ + "/img/truck-delivery.svg";
export { SvgTruckDelivery as ReactComponent };